const onBeforeRenderClient = ()=>{

}

export {onBeforeRenderClient}